<template>
  <div>
    <v-card>
      <v-card-text>
        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="multas"
          item-key="id_auto"
          hide-default-footer
          :items-per-page="50"
        >
          <template v-slot:body="{ items }">
            <tbody v-for="item in items" :key="item.id">
              <tr class="text-left">
                <td>{{ item.autos }}</td>
                <v-chip class="ma-2" color="green" text-color="white">
                  <td> {{ `R$ ${item.valor_infracao}` }}</td>
                </v-chip>
                <td>{{ item.mes }}</td>
                <td>{{ item.ano }}</td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
export default {
  name: "TabelaMultas",
  props: {
    multas: {
      type: Array,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    loaded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      headers: [
        { text: "Autos", value: "autos" },
        { text: "Valor", value: "valor_infracao" },
        { text: "Mês", value: "mes" },
        { text: "Ano", value: "ano" },
      ],
    };
  },
  watch: {
    selected(newVal) {
      this.$emit("selected", [...newVal]);
    },
  },
  methods: {
    getColor(status) {
      if (status == 1) return "green";
      else if (status == 2) return "red";
      else if (status == 3) return "yellow";
    },
    pagination(event) {
      this.$emit("input", event);
    },
  },
};
</script>
